import React, { useState } from "react";
import BasicModal from "../../../../core/BaseComponents/Modal";

function PreviewBgImage(props) {

  return (
    <BasicModal
      popupOpen={props?.showPreviewPopUp}
      popupCloseHandler={() => { props.setShowPreviewPopUp('') }}
      isCross={true}
      heading={'Background Image Preview'}
      popupSize='col-8 px-5'
      bodyMessage={
        <div className="preview-banner-img">
          <img src={props?.showPreviewPopUp} alt='bg-image' width={100} />
        </div>
      }
    />
  );
}

export default PreviewBgImage;
